import { useEffect, useState } from "react";
import { useUserStore } from "../../../store/user.store";
import { Box, Center, Loader } from "@mantine/core";
import NoAppointmentFound from "./NoAppointmentFound";
import PatientSignUp from "./PatientSignUp";

const AppointmentChecker = ({ isGeneralClinic = true }: { isGeneralClinic?: boolean}) => {
    const {
        getGeneralEvents,
        getBehaviorEvents,
        events,
    } = useUserStore((state) => state);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            if (isGeneralClinic) {
                await getGeneralEvents();
            } else {
                await getBehaviorEvents();
            }
            setLoading(false);
        };
        fetchData();
    }, [getBehaviorEvents, getGeneralEvents, isGeneralClinic]);

    return (
        <Box m="lg">
            {loading &&
                <Center>
                    <Loader />
                </Center>
            }
            {
                !loading && events.length === 0 &&
                <NoAppointmentFound />
            }
            {
                !loading && events.length > 0 &&
                <PatientSignUp isGeneralClinic={isGeneralClinic} />
            }
        </Box>
    );
};

export default AppointmentChecker;